import type { MetaReducer } from '@ngrx/store';
import { NGRX_STORAGE_KEYS } from '../../../../core/store/ngrx-persisted-state.keys';
import { createStorageSyncMetaReducer } from '../../../../core/store/ngrx-storage-sync.meta-reducer';
import { ApplyJobState } from './apply-job.models';
import { applyJobFeature } from './apply-job.reducer';

function toSerializableApplyJobState(state: ApplyJobState): ApplyJobState {
  if (!state.formValue) {
    return state;
  }

  const formValue = {
    ...state.formValue,
    applications: state.formValue.applications.map((application) => ({
      ...application,
      coverLetter: null,
      _coverLetterFile: null
    }))
  };

  return { ...state, formValue };
}

function shouldClearFromStorage(state: ApplyJobState): boolean {
  return !state.context && !state.formValue && state.selectedStudents.length === 0;
}

function parseApplyJobState(raw: unknown): ApplyJobState | null {
  return raw && typeof raw === 'object' ? (raw as ApplyJobState) : null;
}

export const metaReducers: MetaReducer[] = [
  createStorageSyncMetaReducer<ApplyJobState>({
    featureKey: applyJobFeature.name,
    storageKey: NGRX_STORAGE_KEYS.applyJob,
    shouldClearFromStorage,
    serialize: toSerializableApplyJobState,
    deserialize: parseApplyJobState
  })
];
